import React from 'react';
type DemoSectionHeaderProps = {
  title: string;
  description?: string;
  actions?: React.ReactNode;
};
export function DemoSectionHeader({
  title,
  description,
  actions
}: DemoSectionHeaderProps) {
  return <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-441" data-mp="30ihlsgudr5uu">
      <div className="max-w-3xl" data-id="element-442" data-mp="34ijqkyvewfec">
        <h1 className="font-heading text-3xl font-bold tracking-tight text-ink-dark" data-id="element-443" data-mp="34hqgpp15p9rz">{title}</h1>
        {description && <p className="mt-2 leading-relaxed text-ink-muted" data-id="element-444" data-mp="2qptrbsqvhdza">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap gap-2" data-id="element-445" data-mp="2vkpvtsdaptta">{actions}</div>}
    </div>;
}